import { createSystem, defaultConfig } from '@chakra-ui/react';

// Custom theme configuration for Chakra UI v3
// Primary color: Lighter Blue (#3b82f6) - Professional and approachable
const theme = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        // Brand colors (keeping original)
        brand: {
          50: { value: '#e3f2fd' },
          100: { value: '#bbdefb' },
          200: { value: '#90caf9' },
          300: { value: '#64b5f6' },
          400: { value: '#42a5f5' },
          500: { value: '#2196f3' },
          600: { value: '#1e88e5' },
          700: { value: '#1976d2' },
          800: { value: '#1565c0' },
          900: { value: '#0d47a1' },
        },
        // Primary colors - Lighter Blue palette
        primary: {
          50: { value: '#eff6ff' },   // Very pale blue
          100: { value: '#dbeafe' },  // Light blue background
          200: { value: '#bfdbfe' },  // Lighter blue
          300: { value: '#93c5fd' },  // Medium light blue
          400: { value: '#60a5fa' },  // Light accent blue
          500: { value: '#3b82f6' },  // Main primary blue (lighter)
          600: { value: '#2563eb' },  // Reference color (darker blue)
          700: { value: '#1d4ed8' },  // Darker blue
          800: { value: '#1e40af' },  // Even darker blue
          900: { value: '#1e3a8a' },  // Darkest blue
        },
        // Override pink with blue (CSS variables will handle most, but this ensures consistency)
        pink: {
          50: { value: '#eff6ff' },
          100: { value: '#dbeafe' },
          200: { value: '#bfdbfe' },
          300: { value: '#93c5fd' },
          400: { value: '#60a5fa' },
          500: { value: '#3b82f6' },
          600: { value: '#2563eb' },
          700: { value: '#1d4ed8' },
          800: { value: '#1e40af' },
          900: { value: '#1e3a8a' },
        }
      },
      fonts: {
        heading: { value: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif` },
        body: { value: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif` },
      },
    },
  },
});

export default theme;